<app-lfsa-card [innTemplate]="enviarTemplateArbol" titulo="Estructura Menú">
</app-lfsa-card>
<ng-template #enviarTemplateArbol>
    <div class="row">
        <div class="col-md-12">
            <h4>- {{descripcionMenuSuperior}}</h4>
            <ul>
                <li *ngFor="let item of rowData">
                    <h5>{{item.descripcion}}</h5>
                    <ul>
                        <li>Agregar Nivel 3 ?</li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplate" titulo="Nivel 2 ({{descripcionMenuSuperior}})">
</app-lfsa-card>
<ng-template #enviarTemplate>
    <br>
    <form [formGroup]="formulario" novalidate class="form-group">
        <!-- {{ formulario.value | json }} -->
        <div class="row">
            <div class="col-md-5">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get(modelo.descripcion)"
                    formControlName="{{modelo.descripcion}}" [label]="'Menú Nivel 2*'"
                    [placeholder]="'Ingrese el nombre del Menú nivel 2'" [type]="'text'" [id]="'menuN2'">
                </app-lfsa-input>
            </div>
            <div class="col-md-3">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get(modelo.orden)"
                    formControlName="{{modelo.orden}}" [label]="'Orden Nivel 2*'"
                    [placeholder]="'Ingrese el orden del Menú nivel 2'" [type]="'number'" [id]="'orden'">
                </app-lfsa-input>
            </div>
            <div class="col-md-2">
                <label for="">&nbsp;</label>
                <button [disabled]="formulario.invalid" class="{{diccionarioModulo.button.buttonsCss.success}}"
                    (click)="NuevoMenuNivel2()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    {{diccionarioModulo.button.buttonsNombre.agregar}}
                </button>
            </div>
            <div class="col-md-2">
                <label for="">&nbsp;</label>
                <button class="{{diccionarioModulo.button.buttonsCss.danger}}" (click)="goNivel1()">
                    <i class="fas fa-arrow-left"></i>
                    {{diccionarioModulo.button.buttonsNombre.regresar}}
                </button>
            </div>
        </div>
        <!-- <br> -->
        <!-- <div class="row">

        </div> -->
        <br>

    </form>
    <ag-grid-angular [floatingFilter]="true" class="{{diccionarioModulo.agGrid.class}}" #agGrid
        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</ng-template>
